import { Loader } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { TaskItem } from 'src/Components/Tasks/TaskItem';
import useUpdateTask from 'src/Hooks/Mutations/useUpdateTask';
import useFetchTasksByRelatedEntity from 'src/Hooks/Queries/useFetchTasksByRelatedEntity';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { TaskStatus } from 'src/types/task.types';

import styles from './RelatedTasksList.module.scss';
import { Props } from './RelatedTasksList.types';

const RelatedTasksList = ({ entityType, entityId, hideTitle = false }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const assetId = useCurrentAssetId();
  const { data: tasks, isLoading } = useFetchTasksByRelatedEntity(
    assetId ?? '',
    entityType,
    entityId
  );
  const { mutate: updateTask } = useUpdateTask(assetId ?? '');

  if (isLoading) {
    return <Loader size="sm" />;
  }

  if (!tasks || tasks.length === 0) {
    return null;
  }

  const handleStatusChange = (taskId: string, newStatus: TaskStatus) => {
    updateTask({ taskId, data: { status: newStatus } });
  };

  return (
    <div className={styles.container}>
      {!hideTitle && <div className={styles.title}>{t('tasks.relatedTasks', 'Tâches liées')}</div>}
      {tasks.map(task => (
        <TaskItem
          key={task.id}
          task={task}
          onStatusChange={handleStatusChange}
          onClick={() => navigate(`/asset/${assetId}/tasks/${task.id}`)}
        />
      ))}
    </div>
  );
};

export default RelatedTasksList;
